var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationEmptyStateUps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #212529;\n      }\n\n      .cls-3 {\n        fill: #7e0386;\n      }\n\n      .cls-4 {\n        fill: none;\n      }\n\n      .cls-5 {\n        fill: #eef0f2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 0,
    width: 96,
    height: 96
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11652",
    "data-name": "Grupo 11652"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1365",
    "data-name": "Elipse 1365",
    className: "cls-5",
    cx: 48,
    cy: 48,
    r: 38
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11651",
    "data-name": "Grupo 11651"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11650",
    "data-name": "Grupo 11650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11645",
    "data-name": "Grupo 11645"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7284",
    "data-name": "Caminho 7284",
    className: "cls-1",
    d: "M71.65,30.37l-.24-.88c-.61-2.69-3.28-4.38-5.97-3.77l-11.24,3.01h0c1.51-4.67,2.71-10.66,1.32-15.5-.31-1.35-1.04-2.56-2.1-3.45-1.91-1.4-4.58-.6-6.17,1.06s-2.42,3.98-3.37,6.15c-3.08,7.19-8.09,13.38-14.48,17.88h0l8.27,33.36,19.02-5.1,1.57-.42,4.73-1.27,11.24-3.01c2.63-.82,4.1-3.62,3.29-6.25l-.24-.88c-.61-2.69-3.28-4.38-5.97-3.77h0c2.63-.82,4.11-3.62,3.29-6.26l-.24-.88c-.61-2.69-3.28-4.38-5.97-3.77h0c2.63-.83,4.09-3.62,3.28-6.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7285",
    "data-name": "Caminho 7285",
    className: "cls-2",
    d: "M37.66,68.94c-.32,0-.6-.22-.68-.53l-8.27-33.36c-.07-.28,.04-.58,.29-.75,6.28-4.43,11.21-10.52,14.24-17.58l.44-1.02c.69-1.95,1.73-3.76,3.07-5.34,1.73-1.81,4.8-2.82,7.09-1.15,1.19,.98,2.02,2.32,2.36,3.83,1.35,4.72,.32,10.39-.95,14.68l10.01-2.68c3.06-.7,6.12,1.21,6.83,4.27l.24,.88c.41,1.48,.24,3.06-.46,4.42-.26,.5-.59,.95-.99,1.35,2.04,.59,3.61,2.21,4.13,4.26l.24,.88c.57,2.04,.02,4.23-1.45,5.76,.54,.15,1.06,.37,1.53,.67,1.29,.83,2.22,2.11,2.61,3.59l.24,.88c.41,1.48,.24,3.05-.46,4.42-.68,1.33-1.88,2.31-3.32,2.7l-36.55,9.79c-.06,.02-.12,.02-.19,.02Zm-7.48-33.76l7.98,32.2,35.86-9.61c1.06-.29,1.95-1.02,2.44-2,.54-1.05,.67-2.26,.35-3.4l-.24-.88c-.3-1.14-1.01-2.13-2.01-2.77-.92-.6-2.05-.78-3.11-.51-.37,.1-.76-.12-.86-.49h0c-.02-.07-.02-.13-.02-.19,0-.32,.21-.59,.52-.68,2.26-.72,3.5-3.14,2.79-5.39l-.24-.88c-.51-2.31-2.8-3.78-5.11-3.28-.37,.1-.76-.12-.86-.5-.02-.06-.02-.12-.02-.18,0-.32,.22-.59,.52-.68,1.06-.29,1.94-1.01,2.44-1.99,.54-1.05,.67-2.26,.35-3.4h0l-.24-.88c-.51-2.31-2.8-3.78-5.11-3.28l-11.23,3.01c-.37,.1-.76-.12-.86-.5-.04-.13-.03-.27,.01-.4,1.36-4.21,2.7-10.25,1.31-15.09-.26-1.2-.91-2.28-1.84-3.08-1.64-1.2-3.94-.39-5.25,.98-1.21,1.46-2.16,3.13-2.79,4.92l-.45,1.03c-3.07,7.15-8.03,13.33-14.33,17.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11646",
    "data-name": "Grupo 11646"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_3",
    "data-name": "Linha 3",
    className: "cls-4",
    x1: 69.22,
    y1: 36.48,
    x2: 52.43,
    y2: 40.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17382",
    "data-name": "Ret\\xE2ngulo 17382",
    className: "cls-2",
    x: 51.43,
    y: 38.03,
    width: 18.79,
    height: 1.4,
    transform: "translate(-7.95 17.06) rotate(-15)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11647",
    "data-name": "Grupo 11647"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_4",
    "data-name": "Linha 4",
    className: "cls-4",
    x1: 72.07,
    y1: 47.14,
    x2: 55.28,
    y2: 51.64
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17383",
    "data-name": "Ret\\xE2ngulo 17383",
    className: "cls-2",
    x: 54.28,
    y: 48.69,
    width: 18.79,
    height: 1.4,
    transform: "translate(-10.61 18.16) rotate(-15)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11648",
    "data-name": "Grupo 11648"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_5",
    "data-name": "Linha 5",
    className: "cls-4",
    x1: 54.62,
    y1: 28.61,
    x2: 49.48,
    y2: 29.99
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17384",
    "data-name": "Ret\\xE2ngulo 17384",
    className: "cls-2",
    x: 48.69,
    y: 28.6,
    width: 6.72,
    height: 1.4,
    transform: "translate(-5.81 14.47) rotate(-15)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11649",
    "data-name": "Grupo 11649"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17385",
    "data-name": "Ret\\xE2ngulo 17385",
    className: "cls-3",
    x: 22.73,
    y: 35.57,
    width: 11.96,
    height: 34.55,
    transform: "translate(-12.71 9.24) rotate(-15.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7286",
    "data-name": "Caminho 7286",
    className: "cls-2",
    d: "M26.9,71.94l-9.31-34.73,12.9-3.46,9.31,34.73-12.9,3.46Zm-7.59-33.74l8.58,32.01,10.19-2.73-8.58-32.01-10.19,2.73Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationEmptyStateUps);
export default __webpack_public_path__ + "static/media/illustration_empty-state-ups.2b64baf39821df82ab5032c93fb13e4d.svg";
export { ForwardRef as ReactComponent };